import { memo } from "react";
import ListGroup from "react-bootstrap/ListGroup";

function ListComponent({ children, index, variant, className }) {
  return (
    <ListGroup defaultActiveKey={index} variant={variant}>
      <ListGroup.Item className={className}>{children}</ListGroup.Item>
    </ListGroup>
  );
}

export default memo(ListComponent);
